( function( $ ) {

    $(document).ready( function() {

        if ($('.wp-block-st-post-search').length > 0) {

            function formatPost(post) {
                if (!post.id) {
                    return post.text;
                }
        
                var $container = $(`
                    <div class="select2-result-post clearfix">
                        <div class="select2-thumbnail" style="float: left; margin-right: 10px;">
                            <img src="${post.image}" style="width: 80px; height: 50px; object-fit: cover;" />
                        </div>
                        <div class="select2-title">${post.text}</div>
                    </div>
                `);
        
                return $container;
            }

            $('.post-search').select2({
                dropdownAutoWidth: true,
                multiple: false,
                theme: "flat",
                ajax: {
                    url: postSearch.ajaxurl,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            action: 'select2_search_posts',
                            q: params.term,
                            nonce: postSearch.nonce
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data.results
                        };
                    },
                    cache: true
                },
                templateResult: formatPost,
                templateSelection: function (post) {
                    return post.text || post.id;
                },
                minimumInputLength: 3,
                escapeMarkup: function (markup) { return markup; }
            });

            $('.post-search').on('select2:select', function (e) {
                const permalink = e.params.data.permalink;
                if (permalink) {
                    window.location.href = permalink;
                }
            });

        }
        

    } );

} )( jQuery );
